import { createSelector } from 'reselect'
import { selectBase } from './selectBase'

export function makeSelectIsBootstrapTypesLoaded(types) {
  return createSelector(selectBase, bootstrap =>
    types.map(type => bootstrap[type] === 'LOADED').every(loaded => loaded)
  )
}
